import { useCallback, useMemo } from "react";

import { FilterId, FilterType } from "@/Components/v2/organism/Header/Header";
import { useBrandEquityStore } from "@/pages/brand-equity/store/useBrandEquityStore";

export const useAvailableFilters = () => {
  const { setTargetNode } = useBrandEquityStore();
  const { targetNodeUUID } = useBrandEquityStore((state) => state.filters);

  const handleTargetNodeChange = useCallback(
    (targetNode: string | null) => {
      setTargetNode(targetNode);
    },
    [setTargetNode]
  );

  const targetNodeFilter = useMemo(
    () => ({
      id: FilterId.BusinessUnit,
      label: "Business Unit",
      type: FilterType.BusinessUnit,
      value: targetNodeUUID,
      onChange: handleTargetNodeChange,
    }),
    [targetNodeUUID, handleTargetNodeChange]
  );

  return useMemo(() => {
    return [targetNodeFilter];
  }, [targetNodeFilter]);
};
